import { Component, OnInit } from '@angular/core';
import { ServerService } from '../services/server.service';
import { Router } from '@angular/router';
import * as Feather from 'feather-icons';
import { FormArray, FormControl, FormGroup, Validators } from '@angular/forms';
declare var iziToast: any;
declare var $: any;
import Swal from 'sweetalert2'
import { v4 as uuidv4 } from 'uuid';
import { Location } from '@angular/common';
@Component({
  selector: 'app-dashboard',
  templateUrl: './dashboard.component.html',
  styleUrls: ['./dashboard.component.css']
})
export class DashboardComponent implements OnInit {
  dealregistration: any = [];
  recordNotFound = false;
  pageLimit = 4;
  paginationData: any = { "info": "hide" };
  mconnectpaginationData: any = { "info": "hide" };
  calltelpaginationData: any = { "info": "hide" };
  voippaginationData: any = { "info": "hide" };
  offset_count = 0;
  commissiondata: any = [];
  callbalances: any = {};
  newsevents: any = [];
  dashcount: any = [];
  userperms: any = [];
  pn: any = [];
  cachecleardata = false;
  locals: any = [];
  international: any = [];
  paypal: any = [];
  selectbank = "loc";
  counts: any = {};

  commission_total_details: any = [];
  year_amount: any = [];
  commision;
  reseller_state;


  newseventsmodallist: any = [];
  blgshow = '1';

  datas: any;
  loads = false;
  customer_id: any;
  blog_list: any;
  customerAccout;
  mconnectBLogs: any;
  calltelblogs: any;
  mrvoipblogs: any;
  minThrehold: any;
  showInput = false;
  addcredits: FormGroup;
  constructor(private router: Router,private location: Location, public serverService: ServerService) {
    this.selctedbnk('loc')
    this.serverService.emailcount.subscribe( (val:any) => 
    {
          console.log(val)
          this.OmniticketCount();
    })
  }




  ngAfterViewInit() {
    // this.selectbank= "loc";

    Feather.replace();

  }
  ngOnInit(): void {

    this.addcredits = new FormGroup({
      'customername': new FormControl(localStorage.getItem('cn'),
        Validators.required),
      'topupvalue': new FormControl(null, Validators.required),
    });
  
    this.get_blogdata({});
    this.getMconnectBLog({});
    this.getcalltelBlogs({});
    this.getMrvoipBLog({});
    // this.gooldcms()
    if (localStorage.getItem('enable') == '1') {
      localStorage.setItem('enable', '0');
      location.reload()

    } else {

      // this.selectbank= "loc";
      this.selctedbnk('loc')

      this.permissions()
      this.callbalance()
      // this.ticket_count()
      this.OmniticketCount()
      this.dashboard_Count()
      this.newseventslist({})
      this.commissiondetailslist()
      this.commissiondetails_def()
      // if(localStorage.getItem('show') == '1'){
      // localStorage.setItem('show','0'); 
      this.newseventsmodal()
      // }
    }





  }


  gooldcms() {
    this.loads = true;
    setTimeout(() => {

      let customer_id: any = localStorage.getItem('en');
      this.datas = uuidv4();
      var cust_id = btoa(customer_id)
      this.loads = false;
      // var sendurl ='https://erp.cal4care.com/cms_old/loginProcess_old_conv.php?Aghwj=M'+cust_id+'=&bmVrb3Q='+this.datas+'';
      var sendurl = 'https://cmsdev1.cal4care.com/cms_old/loginProcess_old_conv.php?Aghwj=M' + cust_id + '=&bmVrb3Q=' + this.datas + '';

      // // console.log(sendurl)

      // https://erp.cal4care.com/cms_new/cms_data_redirect.php?action=login_finger_chk&customer_email='+this.emailid+''
      window.open(sendurl, "_self");

    }, 2000);

  }





  // changeColor(i){
  //     this.selectedIndex = i;
  //   }



  selctedbnk(val) {
    this.selectbank = val;
  }
  check() {
    this.router.navigate(['/referral']);

  }

  readmores(id) {
    $('#eventmodal').modal('hide');
    localStorage.setItem('blk', id);
    this.router.navigate(['blogdetail'], { state: { blogid: id } });


  }


  newseventsmodal() {
    this.blgshow = localStorage.getItem('blg');

    if (this.blgshow == '1') {
      let datas: any = new Object();
      let datasend: any = new Object();
      let access_token: any = localStorage.getItem('at');
      let customer_id: any = localStorage.getItem('en');


      datas.action = "news_events";
      datas.customer_id = customer_id;
      datas.limit = 3;
      datas.offset = 0;


      datasend.access_token = access_token;
      datasend.operation = "curlDatas";
      datasend.moduleType = "login";
      datasend.api_type = "web";
      datasend.element_data = datas;
      this.serverService.sendServer(datasend).subscribe((response: any) => {
        // // console.log(response)

        localStorage.setItem('blg', '0');
        if (response.status == "true") {
          this.newseventsmodallist = response.List
          $('#eventmodal').modal('show');
        }
        else {
          this.newseventsmodallist = [];

        }



      },
        (error) => {
          //        // console.log(error);
        });
    }
  }
  // ticket_count(){

  //   let datas:any =new Object();
  //  let datasend:any = new Object();
  //     let access_token: any=localStorage.getItem('at');
  //     let customer_id: any=localStorage.getItem('en');


  // datas.action="ticket_count";
  // datas.customer_id = customer_id;


  //  datasend.access_token=access_token;
  //   datasend.operation="curlDatas";
  //   datasend.moduleType="login";
  //   datasend.api_type="web";
  //   datasend.element_data = datas;
  //       this.serverService.sendServer(datasend).subscribe((response: any) => {
  // // console.log(response)
  //         if(response.status=="true"){
  //      this.counts = response.counts

  //           }
  //         else{
  // this.counts={}

  //         }

  //       }, 
  //       (error)=>{
  //           // console.log(error);
  //       });

  // }


  readmore_blogs(links) {
    //   localStorage.setItem('blk',id); 
    // this.router.navigate(['blogdetail'], { state: {blogid:id} });
    window.open(links, "_blank");

  }


  OmniticketCount() {

    let datas: any = new Object();
    let datasend: any = new Object();
    let access_token: any = localStorage.getItem('at');
    let customer_id: any = localStorage.getItem('en');


    datas.action = "omni_ticketCount";
    // datas.customer_id = 'MzQ5';
    datas.customer_id = customer_id;


    datasend.access_token = access_token;
    datasend.operation = "curlDatas";
    datasend.moduleType = "ticket";
    datasend.api_type = "web";
    datasend.element_data = datas;
    this.serverService.sendServer(datasend).subscribe((response: any) => {
      // // console.log(response)
      if (response.status == "true") {
        this.counts = +response.counts.open + +response.counts.unread;

      }
      else {
        this.counts = {}

      }

    },
      (error) => {
        // // console.log(error);
      });

  }



  callbalance() {

    let datas: any = new Object();
    let datasend: any = new Object();
    let access_token: any = localStorage.getItem('at');
    let customer_id: any = localStorage.getItem('en');


    datas.action = "call_balance";
    datas.customer_id = customer_id;

    datasend.access_token = access_token;
    datasend.operation = "curlDatas";
    datasend.moduleType = "login";
    datasend.api_type = "web";
    datasend.element_data = datas;
    this.serverService.sendServer(datasend).subscribe((response: any) => {
      // console.log(response)
      if (response.status == "true") {
        this.callbalances = response.call_balance_list

      }
      else {
        this.callbalances = {}
      }
      // console.log(this.callbalances)
    },
      (error) => {
        // console.log(error);
      });
  }


  dashboard_Count() {

    let datas: any = new Object();
    let datasend: any = new Object();
    let access_token: any = localStorage.getItem('at');
    let customer_id: any = localStorage.getItem('en');


    datas.action = "dashboardCount";
    datas.customer_id = customer_id;

    datasend.access_token = access_token;
    datasend.operation = "curlDatas";
    datasend.moduleType = "login";
    datasend.api_type = "web";
    datasend.element_data = datas;
    this.serverService.sendServer(datasend).subscribe((response: any) => {
      // console.log(response)
      if (response.status == "true") {
        this.dashcount = response.List

      }

    },
      (error) => {
        // console.log(error);
      });
  }



  newseventslist(data) {
    Swal.fire('Loading Dashboard')
    Swal.showLoading()
    var list_data = this.listDataInfo(data);

    // // console.log(this.serverService.ci)
    let datas: any = new Object();
    let datasend: any = new Object();
    let access_token: any = localStorage.getItem('at');
    let customer_id: any = localStorage.getItem('en');


    datas.action = "news_events";
    datas.customer_id = customer_id;
    datas.limit = list_data.limit;
    datas.offset = list_data.offset;


    datasend.access_token = access_token;
    datasend.operation = "curlDatas";
    datasend.moduleType = "login";
    datasend.api_type = "web";
    datasend.element_data = datas;
    this.serverService.sendServer(datasend).subscribe((response: any) => {
      // console.log(response)
      if (response.status == "true") {
        Swal.close()
        this.newsevents = response.List

      }
      else {
        Swal.close()
        this.newsevents = [];

      }
      this.offset_count = list_data.offset;
      this.paginationData = this.serverService.pagination({ 'offset': response.Offset, 'total': response.Total, 'page_limit': this.pageLimit });
      // console.log(this.paginationData);
      this.recordNotFound = this.newsevents.length == 0 ? true : false;



    },
      (error) => {
        // console.log(error);
      });

  }


  listDataInfo(list_data) {
    // console.log(list_data)
    list_data.search_text = list_data.search_text == undefined ? "" : list_data.search_text;
    // list_data.order_by_name = list_data.order_by_name == undefined ? "user.user_id" : list_data.order_by_name;
    // list_data.order_by_type = list_data.order_by_type == undefined ? "desc" : list_data.order_by_type;
    list_data.limit = list_data.limit == undefined ? this.pageLimit : list_data.limit;
    list_data.offset = list_data.offset == undefined ? 0 : list_data.offset;
    return list_data;
  }

  getsearch(searchValue: string): void {
    // console.log(searchValue);
    this.newseventslist({ 'search_text': searchValue })
  }

  checkEven(val) {
    return (val % 2 == 0);
  }


  commissiondetailslist() {

    let datas: any = new Object();
    let datasend: any = new Object();
    let access_token: any = localStorage.getItem('at');
    let customer_id: any = localStorage.getItem('en');


    datas.action = "commission_details";
    datas.customer_id = customer_id;

    datasend.access_token = access_token;
    datasend.operation = "curlDatas";
    datasend.moduleType = "login";
    datasend.api_type = "web";
    datasend.element_data = datas;
    this.serverService.sendServer(datasend).subscribe((response: any) => {
      // console.log(response)
      if (response.status == "true") {
        this.commissiondata = response.List;
        this.locals = response.bank_detail1;
        this.international = response.bank_detail2;
        this.paypal = response.bank_detail3;
        if (response.commission_total_details != "") {
          this.commission_total_details = response.commission_total_details;

        } else {
          this.commission_total_details = [];

        }

        this.year_amount = response.year_amount;

        for (var i = 0; i < this.commission_total_details.length; i++) {
          if (i % 2 == 0) {
            // console.log("even")
            this.commission_total_details[i].background = "#87ceeba1";
          } else {
            this.commission_total_details[i].background = "#f5deb3a8";
          }
        }


        for (var i = 0; i < this.year_amount.length; i++) {
          if (i % 2 == 0) {
            // console.log("even")
            this.year_amount[i].background = "#87ceeba1";
          } else {
            this.year_amount[i].background = "#f5deb3a8";
          }
        }



        // console.log(this.year_amount)
        this.commision = response;



      }

    },
      (error) => {
        // console.log(error);
      });
  }



  permissions() {
    this.pn = [];
    this.userperms = [];
    // this.serverService.invoice=0;
    // this.serverService.prepaidnote=0;
    // this.serverService.creditnote = 0;
    // this.serverService.license = 0;
    // this.serverService.projects = 0;
    // this.serverService.phones =0;
    // this.serverService.leads =0;
    // this.serverService.reseller =0;
    // this.serverService.callhistory =0;
    // this.serverService.cxbuy =0;
    // this.serverService.iddpricelist =0;
    // this.serverService.call4tellicense =0;
    // this.serverService.supportticket =0;
    // this.serverService.users =0;


    let data: any = new Object();
    let datasend: any = new Object();
    let access_token: any = localStorage.getItem('at');
    let customer_id: any = localStorage.getItem('en');


    data.action = "contact_flag";
    data.customer_id = customer_id;
    data.customer_state = localStorage.getItem('customer_state');
    data.cms_user_id = localStorage.getItem('cms_user_id');

    datasend.access_token = access_token;
    datasend.operation = "curlDatas";
    datasend.moduleType = "login";
    datasend.api_type = "web";

    datasend.element_data = data;
    this.serverService.sendServer(datasend).subscribe((response: any) => {
      // console.log(response)
      if (response.status == "true") {
        // this.countryflagdata = response.cms_menu_data;
        // this.userperms = localStorage.getItem('pn').split(',')
        //   for (var i = 0; i < this.userperms.length; i++) {
        //   this.pn.push(atob(this.userperms[i]))
        // }
        if(response.customer_details.cache_clear_flag == 0){
          // this.cachecleardata = true;
          // setTimeout(() => {
          //   $('#cacheclear').modal('show');
          // }, 1000);
        
        }
       
        
        else{
          // this.cachecleardata = false;
          
        }
        this.customerAccout=response.customer_details.customerCode;
        this.serverService.callhistorypbx = response.customer_details.cms_username_dispaly;
        this.serverService.callhistoryvspbx = response.customer_details.cms_vs_pbx_dispaly;
        this.userperms = response.customer_details.cus_permission.split(',');
        this.reseller_state = response.customer_details.reseller_state;
        // console.log(this.userperms)
        for (var i = 0; i < this.userperms.length; i++) {

          this.pn.push(btoa(this.userperms[i]))

        }


        localStorage.setItem('pn', this.pn);

        for (var i = 0; i < this.userperms.length; i++) {

          if (this.userperms[i] == '101') {
            this.serverService.invoice = 1;
            this.serverService.referral = 1;
          }
          if (this.userperms[i] == '102') {
            this.serverService.prepaidnote = 1;
            this.serverService.creditnote = 1;
          }
          if (this.userperms[i] == '103')
            this.serverService.license = 1;
          if (this.userperms[i] == '104')
            this.serverService.projects = 1;
          if (this.userperms[i] == '105')
            this.serverService.phones = 1;
          if (this.userperms[i] == '107')
            this.serverService.leads = 1;
          if (this.userperms[i] == '131')
            this.serverService.reseller = 1;
          if (this.userperms[i] == '109')
            this.serverService.callhistory = 1;
          if (this.userperms[i] == '118')
            this.serverService.cxbuy = 1;
          if (this.userperms[i] == '134')
            this.serverService.iddpricelist = 1;
          if (this.userperms[i] == '138')
            this.serverService.call4tellicense = 1;
          if (this.userperms[i] == '157')
            this.serverService.supportticket = 1;
          if (this.userperms[i] == '110')
            this.serverService.users = 1;
          if (this.userperms[i] == '136')
            this.serverService.callbalance = 1;
          if (this.userperms[i] == '158')
            this.serverService.licencerenewal = 1;
          if (this.userperms[i] == '159')
            this.serverService.dealregistration = 1;
          if (this.userperms[i] == '160')
            this.serverService.gccfirewall = 1;
          if (this.userperms[i] == '163')
            this.serverService.caller_group = 1;
        }

        // console.log(this.serverService.users)
        // console.log(this.serverService.leads)
        // console.log(this.serverService.license)

      }
      else {

      }
    },
      (error) => {
        // console.log(error);
      });

  }

  cacheclear(){


    let data: any = new Object();
    let datasend: any = new Object();
    let access_token: any = localStorage.getItem('at');
    let customer_id: any = localStorage.getItem('en');

    data.action = "update_cache_clear";
    data.customer_id = customer_id;
    datasend.access_token = access_token;
    datasend.operation = "curlDatas";
    datasend.moduleType = "login";
    datasend.api_type = "web";
    datasend.element_data = data;
    this.serverService.sendServer(datasend).subscribe((response: any) => {
      if (response.status == "true") {
        $('#cacheclear').modal('hide');
      }
      else {
      }
    },
      (error) => {
      });

  }


  
  get_blogdata(data) {

    var list_data = this.listDataInfo(data);
    this.customer_id = localStorage.getItem('en');
    let api_req: any = '{"operation":"blog","moduleType":"blog","api_type":"web","element_data":{"customer_id":"' + this.customer_id + '","limit":"' + list_data.limit + '","action":"blog_lists","offset":"' + list_data.offset + '"}}';
    this.serverService.sendServer(api_req).subscribe((response: any) => {
      // console.log(response)
      if (response.status == 'true') {
        this.blog_list = response.post_list;
        // console.log(this.blog_list)
        this.offset_count = list_data.offset;
        // console.log(this.offset_count)
        this.paginationData = this.serverService.pagination({ 'offset': response.Offset, 'total': response.Total, 'page_limit': this.pageLimit });
        // console.log(this.paginationData);
        this.recordNotFound = this.blog_list.length == 0 ? true : false;

      } else {
      }
    },
      (error) => {
        // console.log(error);
      });
  }


  getMconnectBLog(data) {

    var list_data = this.listDataInfo(data);
    this.customer_id = localStorage.getItem('en');
    let api_req: any = '{"operation":"blog","moduleType":"blog","api_type":"web","element_data":{"customer_id":"' + this.customer_id + '","limit":"' + list_data.limit + '","action":"mconnectapps_blog_lists","offset":"' + list_data.offset + '"}}';
    this.serverService.sendServer(api_req).subscribe((response: any) => {
      // // console.log(response)
      if (response.status == 'true') {
        this.mconnectBLogs = response.post_list;
        // // console.log(this.mconnectBLogs)
        this.offset_count = list_data.offset;
        // // console.log(this.offset_count)
        this.mconnectpaginationData = this.serverService.pagination({ 'offset': response.Offset, 'total': response.Total, 'page_limit': this.pageLimit });
        // // console.log(this.mconnectpaginationData);
        this.recordNotFound = this.mconnectBLogs.length == 0 ? true : false;

      } else {
      }
    },
      (error) => {
        // // console.log(error);
      });
  }

  getcalltelBlogs(data) {

    var list_data = this.listDataInfo(data);
    this.customer_id = localStorage.getItem('en');
    let api_req: any = '{"operation":"blog","moduleType":"blog","api_type":"web","element_data":{"customer_id":"' + this.customer_id + '","limit":"' + list_data.limit + '","action":"call4tel_blog_lists","offset":"' + list_data.offset + '"}}';
    this.serverService.sendServer(api_req).subscribe((response: any) => {
      // // console.log(response)
      if (response.status == 'true') {
        this.calltelblogs = response.post_list;
        // // console.log(this.calltelblogs)
        this.offset_count = list_data.offset;
        // // console.log(this.offset_count)
        this.calltelpaginationData = this.serverService.pagination({ 'offset': response.Offset, 'total': response.Total, 'page_limit': this.pageLimit });
        // // console.log(this.calltelpaginationData);
        this.recordNotFound = this.calltelblogs.length == 0 ? true : false;

      } else {
      }
    },
      (error) => {
        // // console.log(error);
      });
  }

  getMrvoipBLog(data) {

    var list_data = this.listDataInfo(data);
    this.customer_id = localStorage.getItem('en');
    let api_req: any = '{"operation":"blog","moduleType":"blog","api_type":"web","element_data":{"customer_id":"' + this.customer_id + '","limit":"' + list_data.limit + '","action":"mrvoip_blog_lists","offset":"' + list_data.offset + '"}}';
    this.serverService.sendServer(api_req).subscribe((response: any) => {
      // // console.log(response)
      if (response.status == 'true') {
        this.mrvoipblogs = response.post_list;
        // // console.log(this.mrvoipblogs)
        this.offset_count = list_data.offset;
        // // console.log(this.offset_count)
        this.voippaginationData = this.serverService.pagination({ 'offset': response.Offset, 'total': response.Total, 'page_limit': this.pageLimit });
        // // console.log(this.voippaginationData);
        this.recordNotFound = this.mrvoipblogs.length == 0 ? true : false;

      } else {
      }
    },
      (error) => {
        // // console.log(error);
      });
  }


  commissiondetails_def() {

    let datas: any = new Object();
    let datasend: any = new Object();
    let access_token: any = localStorage.getItem('at');
    let customer_id: any = localStorage.getItem('en');


    datas.action = "commission_details";
    datas.customer_id = customer_id;


    datasend.access_token = access_token;
    datasend.operation = "curlDatas";
    datasend.moduleType = "login";
    datasend.api_type = "web";
    datasend.element_data = datas;
    this.serverService.sendServer(datasend).subscribe((response: any) => {
      // console.log(response)
      if (response.status == "true") {
        // this.counts = response.counts

      }
      else {
        // this.counts={}

      }

    },
      (error) => {
        // console.log(error);
      });

  }

  addCreditsModal() {
    $('#addcredits').modal('show');
  }


  paymentCredits() {
    if (this.addcredits.valid) {
      let customer_id: any = localStorage.getItem('en');
      let data: any = new Object();
      let datas: any = new Object();
      data.action = "topup_add";
      data.topup_name = "Call Topup Amount";
      data.qty = "1";
      data.customer_id = customer_id;
      data.topup_amount = this.addcredits.value.topupvalue;
      datas.operation = "curlDatas";
      datas.moduleType = "login";
      datas.api_type = "web";
      datas.element_data = data;
      this.serverService.sendServer(datas).subscribe((res: any) => {
        if (res.status == "true") {
          $('#addcredits').modal('hide');
          this.router.navigate(['credit-payments'], { state: { page: this.addcredits.value.topupvalue } });
        }
      })

    }
  }




}
